/**************************************************************************************************/
/*   File: /src/app/shared/components/fileuploader/upload-preview/upload-preview.component.ts     */
/*   Project: newplan-frontend                                                                    */
/*   Created Date: Friday February 22nd 2019                                                      */
/*   Author: Andrea Zamboni andrea.zamboni@trilogis.it                                            */
/*   -----                                                                                        */
/*   Last Modified: Thu May 30 2019                                                               */
/*   Modified By: Andrea Zamboni                                                                  */
/*   -----                                                                                        */
/*   Copyright (c) 2019 Trilogis s.r.l. for SIAG                                                  */
/**************************************************************************************************/
import { NGXLogger } from 'ngx-logger';

import {
  Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges
} from '@angular/core';

import * as fromModels from '../../../models';

/**
 * The upload file preview components
 */
@Component({
  selector: 'nwpl-frnt-upload-preview',
  templateUrl: './upload-preview.component.html',
  styleUrls: ['./upload-preview.component.scss']
})
export class UploadPreviewComponent implements OnInit, OnChanges {

  /**
   * Getting files on the store.
   */
  @Input() files: fromModels.FileModel[];

  /**
   * The text to show
   */
  @Input() confirmText: string;

  /**
   * The upload finished
   */
  @Input() uploadFinished: boolean;

  /**
   * The event for remove file
   */
  @Output() removedFile: EventEmitter<number> = new EventEmitter<number>();

  /**
   * The event for upload files
   */
  @Output() uploadedFiles: EventEmitter<Event> = new EventEmitter<Event>();

  /**
   * The constructor
   * @param logger The ngx logger
   */
  constructor(private logger: NGXLogger) { }

  /**
   * The ng init
   */
  /* istanbul ignore next */
  ngOnInit() {
  }

  /**
  * The ng on init hook
  */
  /* istanbul ignore next */
  ngOnChanges(changes: SimpleChanges) {
    if (changes && changes.files) {
      this.logger.trace('File count is', changes.files.currentValue.length);
    }
  }

  /**
   * On remove file
   * @param id The id
   */
  onRemoveFile(id: number) {
    this.removedFile.emit(id);
  }

  /**
   * On upload files
   * @param $event The event
   */
  onUploadFiles($event: Event) {
    this.uploadedFiles.emit($event);
  }

}
